// extracted by mini-css-extract-plugin
export default {"container":"TarjetaResumen_container__uSOwa","titulo":"TarjetaResumen_titulo__58lHD","numero":"TarjetaResumen_numero__4XS3N"};